import React from 'react';
// eslint-disable-next-line no-unused-vars
import { FastField, Field } from 'formik';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isNumeric, formLabel } from '~/utils/helpers';
import isEmpty from 'lodash/isEmpty';
import { Tooltip } from '~/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function FormSelect({ sm, name, options, defaultValue, className, label, onChangeValue, tooltip }) {
    const labelForm = label || formLabel(name);

    return (
        <>
            {!isEmpty(options) && (
                <FastField name={name}>
                    {({ field, form, meta }) => {
                        const isValid = !meta.error;
                        const isInvalid = meta.touched && !isValid;
                        field.value = field.value ?? ''; //set field value to empty string ("") to avoid `Warning: `value` prop on `input` should not be null`.

                        return (
                            <>
                                <Form.Group
                                    as={Col}
                                    sm={sm}
                                    className={className}
                                >
                                    <Form.Label className="d-flex">
                                        {tooltip ? (
                                            <>
                                                {labelForm}
                                                <Tooltip content={tooltip}>
                                                    <FontAwesomeIcon
                                                        icon={faCircleInfo}
                                                        size="xs"
                                                        className="fa-light fa-fw ml-1"
                                                    />
                                                </Tooltip>
                                            </>
                                        ) : (
                                            labelForm
                                        )}
                                    </Form.Label>
                                    <Form.Control
                                        {...field}
                                        as={'select'}
                                        custom
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            form.setFieldValue(field.name, isNumeric(val) ? parseInt(val) : val);

                                            if (onChangeValue) onChangeValue(form, val);
                                        }}
                                        isInvalid={isInvalid}
                                        value={defaultValue || field.value} //(1)
                                    >
                                        <option value="">Select...</option>
                                        {options.length > 0 &&
                                            options.map((option, i) => {
                                                return (
                                                    <option
                                                        value={option.id}
                                                        key={i}
                                                    >
                                                        {option.name}
                                                    </option>
                                                );
                                            })}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                                </Form.Group>
                            </>
                        );
                    }}
                </FastField>
            )}
        </>
    );
}

FormSelect.defaultProps = {
    sm: 2,
    defaultValue: '',
    className: '',
    label: '',
    onChangeValue: null,
    tooltip: '',
};
FormSelect.propTypes = {
    options: PropTypes.array.isRequired,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    label: PropTypes.string,
    onChangeValue: PropTypes.func,
    tooltip: PropTypes.string,
};
export default FormSelect;

/**Note */
//(1): should use `value` instead of reactboostrap's `defaultValue` to make  React state be the “single source of truth”, else cannot reset select form value. Ref: https://www.reddit.com/r/reactjs/comments/o2oduw/comment/h297fuh/?utm_source=share&utm_medium=web2x&context=3, https://reactjs.org/docs/uncontrolled-components.html#default-values
